import styled from "styled-components";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import SnackBar from "../../components/SnackBar";
import PillarOverviewCreate from "../../components/PillarOverviewCreate";
import axios from "axios";
import LoadingSpinner from "../../components/LoadingSpinner";
import theme from "../../styles/theme";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import SubdomainCreate from "./SubdomainCreate";
import KnowledgeAreaCreate from "./KnowledgeAreaCreate";
import KnowledgeTopicCreate from "./KnowledgeTopicCreate";
import EditSubdomain from "./EditSubdomain";
import EditKnowledgeArea from "./EditKnowledgeArea";
import EditKnowledgeTopic from "./EditKnowledgeTopic";
import EditPillar from "./EditPillar";
import { Icon } from "@mui/material";
import PillarCreate from "./PillarCreate";
import { UserContext } from "../../context/UserContext";

interface Props {
  createMode: string;
  setCreateMode: any;
  editMode: string;
  currentId: any;
  setEditMode: (x: string) => void;
  fetchPillars: () => void;
  isSnackbarOpen: boolean;
  setIsSnackbarOpen: (x: boolean) => void;
  setMessage: (x: string) => void;
  setIsErrorOpen: (x: boolean) => void;
  message: string;
  isErrorOpen: boolean;
  expanded: any;
  setExpanded: (x: any) => void;
  showCreatePillar: any;
  setShowCreatePillar: any;
  showCreateSubdomain: any;
  setShowCreateSubdomain: any;
  showCreateKnowledgeArea: any;
  setShowCreateKnowledgeArea: any;
  showCreateKnowledgeTopic: any;
  setShowCreateKnowledgeTopic: any;
}

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  height: 100%;
`;

const CreateButton = styled(Button)`
  background: ${({ theme }) => theme.color.greenButton};
  box-shadow: 0 2px 5px #808080cc;
  border: none;
  min-height: 40px;
  color: white !important;
`;

const EditButton = styled(Button)`
  background: ${({ theme }) => theme.color.blueButton};
  box-shadow: 0 2px 5px #808080cc;
  border: none;
  min-height: 40px;
  color: white;
  top: 0px;
  margin-left: 10px;
`;

const Header = styled.h4`
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0px;
  text-align: center;
  color: ${({ theme }) => theme.color.darkBlueGray900};
`;

const CustomFlex = styled(FlexBox)`
  padding: 20px 0;
  align-items: center;
  border-bottom: 1px solid #94a3b8;
`;

const CustomGrow = styled(FlexGrow)`
  align-self: stretch;
  flex-grow: 0;
  // padding: 16px;
`;

export const PillarDetail = (props: Props) => {
  const {
    createMode,
    setCreateMode,
    editMode,
    setEditMode,
    currentId,
    fetchPillars,
    isSnackbarOpen,
    setIsSnackbarOpen,
    setMessage,
    setIsErrorOpen,
    message,
    isErrorOpen,
    expanded,
    setExpanded,
    showCreatePillar,
    setShowCreatePillar,
    showCreateSubdomain,
    setShowCreateSubdomain,
    showCreateKnowledgeArea,
    setShowCreateKnowledgeArea,
    showCreateKnowledgeTopic,
    setShowCreateKnowledgeTopic,
  } = props;

  const [isCreateMode, setIsCreateMode] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const userContext = useContext(UserContext);
  const role = userContext.user.role;

  const navigate = useNavigate();

  const resetState = () => {
    setShowCreatePillar(false);
    setShowCreateSubdomain(false);
    setShowCreateKnowledgeArea(false);
    setShowCreateKnowledgeTopic(false);
  };

  const handleCreateButtonClick = () => {
    resetState();
    setIsCreateMode(true);
    switch (createMode) {
      case "Pillar":
        setShowCreatePillar(true);
        break;
      case "Subdomain":
        setShowCreateSubdomain(true);
        break;
      case "Knowledge Area":
        setShowCreateKnowledgeArea(true);
        break;
      case "Knowledge Topic":
        setShowCreateKnowledgeTopic(true);
        break;
    }
  };

  useEffect(() => {
    resetState();
    setIsEditMode(true);
    switch (editMode) {
      case "Pillar":
        setShowCreatePillar(true);
        break;
      case "Subdomain":
        setShowCreateSubdomain(true);
        break;
      case "Knowledge Area":
        setShowCreateKnowledgeArea(true);
        break;
      case "Knowledge Topic":
        setShowCreateKnowledgeArea(false);
        setShowCreateKnowledgeTopic(true);
        break;
      default:
        setIsEditMode(false);
    }
  }, [editMode, isCreateMode]);

  useEffect(() => {
    setIsCreateMode(false);
    if (expanded?.length === 0) {
      setCreateMode("Pillar");
    }
  }, [currentId]);
  const handleCancelEdit = () => {
    setShowCreatePillar(false);
    navigate("/modify/pillar");
  };

  const handleCancelCreate = () => {
    setShowCreatePillar(false);
    navigate("/modify/pillar");
  };

  const createNewPillar = (data: any) => {
    setLoading(true);
    axios
      .post("/pillar/new", data)
      .then((res) => {
        setMessage("Created pillar successfully");
        setIsSnackbarOpen(true);
        setLoading(false);
        fetchPillars();
      })
      .catch((error) => {
        if (error.response) {
          setMessage(error.response.data.error || "Failed to create pillar!");
          setIsErrorOpen(true);
        } else {
          setMessage(error.message || "Failed to create pillar!");
          setIsErrorOpen(true);
        }
        setLoading(false);
      });
  };
  return (
    <div
      style={{
        // height: "95vh",
        flexGrow: 1,
        maxWidth: "50%",
        // padding: 10,
      }}
    >
      <FlexBox
        direction="column"
        align-items="flex-end"
        style={{ background: "white", padding: "10px 10px 30px 10px" }}
      >
        {createMode && (
          <CreateButton
            disabled={role === "instructor"}
            className="reduce_opct_onhover"
            onClick={handleCreateButtonClick}
            style={{ alignSelf: "flex-end", minWidth: 200, gap: 10 }}
          >
            <Icon fontSize="small" style={{ color: "white" }}>
              add_circle_outline_icon
            </Icon>{" "}
            Create {createMode}
          </CreateButton>
        )}
      </FlexBox>

      <div
        style={{
          overflowY: "auto",
          maxHeight: "88vh",
          minHeight: "85vh",
        }}
      >
        {isCreateMode ? (
          <CreateContainer
            isSnackbarOpen={isSnackbarOpen}
            setIsSnackbarOpen={setIsSnackbarOpen}
            message={message}
            handleCancelCreate={handleCancelCreate}
            isErrorOpen={isErrorOpen}
            setIsErrorOpen={setIsErrorOpen}
            createMode={createMode}
            loading={loading}
            createNewPillar={createNewPillar}
            child={
              createMode==="Pillar" ? (
                <PillarCreate
                  setOpen={() => {
                    setIsCreateMode(false);
                    setShowCreatePillar(true);
                  }}
                  onSaveComplete={(data) => {
                    createNewPillar(data);
                    setIsCreateMode(false);
                    setShowCreatePillar(true);
                  }}
                />
              ) : createMode==="Subdomain" ? (
                <SubdomainCreate
                  isSnackbarOpen={isSnackbarOpen}
                  setIsSnackbarOpen={setIsSnackbarOpen}
                  isErrorOpen={isErrorOpen}
                  setIsErrorOpen={setIsErrorOpen}
                  setMessage={setMessage}
                  currentId={currentId}
                  header="Create Subdomain"
                  mode="create"
                  isOpen={true}
                  setOpen={() => {
                    setIsCreateMode(false);
                    setShowCreateSubdomain(false);
                    setShowCreatePillar(true);
                  }}
                  onSaveComplete={() => {
                    fetchPillars();
                    setIsCreateMode(false);
                    setShowCreateSubdomain(false);
                    setShowCreatePillar(true);
                  }}
                />
              ) : createMode==="Knowledge Area" ? (
                <KnowledgeAreaCreate
                  isSnackbarOpen={isSnackbarOpen}
                  setIsSnackbarOpen={setIsSnackbarOpen}
                  isErrorOpen={isErrorOpen}
                  setIsErrorOpen={setIsErrorOpen}
                  setMessage={setMessage}
                  currentId={currentId}
                  header="Create Knowledge Area"
                  mode="create"
                  isOpen={true}
                  setOpen={() => {
                    setIsCreateMode(false);
                    setShowCreateKnowledgeArea(false);
                    setShowCreateSubdomain(true);
                  }}
                  onSaveComplete={() => {
                    fetchPillars();
                    setIsCreateMode(false);
                    setShowCreateKnowledgeArea(false);
                    setShowCreateSubdomain(true);
                  }}
                />
              ) : createMode==="Knowledge Topic"  ? (
                <KnowledgeTopicCreate
                  isSnackbarOpen={isSnackbarOpen}
                  setIsSnackbarOpen={setIsSnackbarOpen}
                  isErrorOpen={isErrorOpen}
                  setIsErrorOpen={setIsErrorOpen}
                  setMessage={setMessage}
                  currentId={currentId}
                  header="Create Knowledge Topic"
                  mode="create"
                  isOpen={true}
                  setOpen={() => {
                    setIsCreateMode(false);
                    setShowCreateKnowledgeTopic(false);
                    setShowCreateKnowledgeArea(true);
                  }}
                  onSaveComplete={() => {
                    fetchPillars();
                    setIsCreateMode(false);
                    setShowCreateKnowledgeTopic(false);
                    setShowCreateKnowledgeArea(true);
                  }}
                />
              ) : (
                <div />
              )
            }
          />
        ) : isEditMode ? (
          <EditContainer
            isSnackbarOpen={isSnackbarOpen}
            setIsSnackbarOpen={setIsSnackbarOpen}
            message={message}
            handleCancelEdit={handleCancelEdit}
            isErrorOpen={isErrorOpen}
            setIsErrorOpen={setIsErrorOpen}
            editMode={editMode}
            loading={loading}
            createNewPillar={createNewPillar}
            child={
              showCreatePillar ? (
                <EditPillar
                  role={role}
                  isSnackbarOpen={isSnackbarOpen}
                  setIsSnackbarOpen={setIsSnackbarOpen}
                  setIsErrorOpen={setIsErrorOpen}
                  setMessage={setMessage}
                  currentId={currentId}
                  header="Edit Pillar"
                  mode="modify"
                  isOpen={true}
                  setOpen={() => {
                    setIsCreateMode(false);
                  }}
                  onSaveComplete={() => {
                    setShowCreatePillar(true);
                    fetchPillars();
                  }}
                />
              ) : showCreateSubdomain ? (
                <EditSubdomain
                  role={role}
                  isSnackbarOpen={isSnackbarOpen}
                  setIsSnackbarOpen={setIsSnackbarOpen}
                  setIsErrorOpen={setIsErrorOpen}
                  setMessage={setMessage}
                  currentId={currentId}
                  header="Edit Subdomain"
                  mode="modify"
                  isOpen={true}
                  setOpen={() => setIsCreateMode(false)}
                  onSaveComplete={() => {
                    setShowCreateSubdomain(true);
                    fetchPillars();
                  }}
                />
              ) : showCreateKnowledgeArea ? (
                <EditKnowledgeArea
                  role={role}
                  isSnackbarOpen={isSnackbarOpen}
                  setIsSnackbarOpen={setIsSnackbarOpen}
                  setIsErrorOpen={setIsErrorOpen}
                  setMessage={setMessage}
                  currentId={currentId}
                  header="Edit Knowledge Area"
                  mode="modify"
                  isOpen={true}
                  setOpen={() => setIsCreateMode(false)}
                  onSaveComplete={() => {
                    setShowCreateKnowledgeArea(true);
                    fetchPillars();
                  }}
                />
              ) : showCreateKnowledgeTopic ? (
                <EditKnowledgeTopic
                  role={role}
                  isSnackbarOpen={isSnackbarOpen}
                  setIsSnackbarOpen={setIsSnackbarOpen}
                  setIsErrorOpen={setIsErrorOpen}
                  setMessage={setMessage}
                  currentId={currentId}
                  header="Edit Knowledge Topic"
                  mode="modify"
                  isOpen={true}
                  setOpen={() => setIsCreateMode(false)}
                  onSaveComplete={() => {
                    setShowCreateKnowledgeTopic(true);
                    fetchPillars();
                  }}
                />
              ) : (
                <div />
              )
            }
          />
        ) : (
          <div />
        )}
      </div>
    </div>
  );
};

const EditContainer = (props: any) => {
  const {
    isSnackbarOpen,
    setIsSnackbarOpen,
    message,
    isErrorOpen,
    setIsErrorOpen,
    editMode,
    loading,
    createNewPillar,
    handleCancelEdit,
    child,
  } = props;
  return (
    <Container>
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={message}
        type="error"
      />

      <div
        className="visible-scrollbar"
        style={{
          overflowY: "auto",
          maxHeight: "88vh",
          minHeight: "85vh",
        }}
      >
        <FlexBox direction="column">
          <CustomGrow>
            <Header>Edit {editMode}</Header>
          </CustomGrow>
          <CustomGrow>
            {loading && <LoadingSpinner />}
            {child}
          </CustomGrow>
        </FlexBox>
      </div>
    </Container>
  );
};

const CreateContainer = (props: any) => {
  const {
    isSnackbarOpen,
    setIsSnackbarOpen,
    message,
    isErrorOpen,
    setIsErrorOpen,
    createMode,
    loading,
    createNewPillar,
    handleCancelCreate,
    child,
  } = props;
  return (
    <Container>
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={message}
        type="error"
      />
      <CustomFlex
        style={{
          minHeight: "inherit",
          height: "100%",
          borderBottom: "none",
          alignItems: "flex-start",
          overflowY: "scroll",
          padding: 0,
          background: "white",
        }}
      >
        <FlexGrow
          className="visible-scrollbar"
          style={{
            overflowY: "auto",
            maxHeight: "88vh",
            minHeight: "85vh",
          }}
        >
          <FlexBox direction="column">
            <CustomGrow>
              <Header>Create New {createMode}</Header>
            </CustomGrow>
            <CustomGrow>
              {loading && <LoadingSpinner />}
              {child}
            </CustomGrow>
          </FlexBox>
        </FlexGrow>
      </CustomFlex>
    </Container>
  );
};
